import { applyPhoneMask } from '/assets/js/utils/phone-mask';
import { notice } from '/assets/js/utils/notices';
import {nsFetch} from "/assets/js/utils/fetch";

class EditModal {
    constructor() {
        this.modal = document.getElementById('edit');
        this.modalContent = document.querySelector('.edit-modal__content');
        this.modalContentWrap = document.querySelector('.edit-modal__content-wrap');
        this.header = document.querySelector('.header');
        this.closeButton = document.querySelector('.edit-modal__content-close button[data-modal-close]');
        this.accountDisplayName = document.querySelector('.account-page__aside-user-name');

        this.phoneInput = this.modal?.querySelector('[name="phone"]');
        this.emailInput = this.modal?.querySelector('[name="email"]');
        this.nameInput = this.modal?.querySelector('[name="name"]');
        this.saveAccountBtn = this.modal?.querySelector('#save_account');

        this.currentPasswordField = this.modal?.querySelector('[data-current-password-field]');
        this.currentPasswordInput = this.currentPasswordField?.querySelector('[name="current_password"]');

        this.init();
    }

    init() {
        if (this.phoneInput) {
            this.initPhoneMask();
            this.initPhoneChangeWatcher();
        }

        if (this.modal) {
            this.initModalClose();
            this.initModalPosition();
        }

        if (this.saveAccountBtn) {
            this.initSaveAccountBtn();
        }
    }

    initPhoneMask() {
        this.phoneInput.addEventListener('input', applyPhoneMask);
    }

    isPhoneChanged() {
        return this.phoneInput.value !== this.phoneInput.dataset.originalPhone;
    }

    initPhoneChangeWatcher() {
        this.phoneInput.addEventListener('input', () => {
            this.togglePasswordField();
        });
    }

    togglePasswordField() {
        if (!this.currentPasswordField) return;

        if (this.isPhoneChanged()) {
            this.currentPasswordField.removeAttribute('hidden');
        } else {
            this.currentPasswordField.setAttribute('hidden', '');
            if (this.currentPasswordInput) {
                this.currentPasswordInput.value = '';
            }
        }
    }

    initSaveAccountBtn() {
        this.saveAccountBtn.addEventListener('click', () => {
            this.handleSave();
        });
    }

    handleSave() {
        if (this.isPhoneChanged() && !this.currentPasswordInput?.value) {
            notice('Для смены номера телефона введите текущий пароль', 'error');
            this.currentPasswordInput?.focus();
            return;
        }

        this.saveChanges();
    }

    saveChanges = async () => {
        this.saveAccountBtn.classList.add('is-loading');

        const data = {
            'name': this.nameInput.value,
            'phone': this.phoneInput.value,
            'email': this.emailInput.value,
            'current_password': this.currentPasswordInput?.value || '',
        };

        const response = await nsFetch.doFetch({
            action: 'ns_save_account',
            body: data
        });

        if (!response.success) {
            notice(response.data.message, 'error');
        } else {
            this.phoneInput.dataset.originalPhone = this.phoneInput.value;

            if (this.currentPasswordInput) {
                this.currentPasswordInput.value = '';
            }
            this.togglePasswordField();

            if (this.accountDisplayName.textContent != response.data.name) {
                this.accountDisplayName.textContent = response.data.name;
            }

            if (this.emailInput.dataset.originalEmail != this.emailInput.value) {
                this.emailInput.insertAdjacentHTML(
                    'afterend',
                    `<span class="input__label input__label--notice">Подтвердите смену Email по ссылке в ${this.emailInput.value}</span>`
                );
                this.emailInput.dataset.originalEmail = this.emailInput.value;
            }

            if (this.modal) {
                this.modal.classList.remove('is-open');
            }

            notice(response.data.message, 'info');
        }

        this.saveAccountBtn.classList.remove('is-loading');
    }

    initModalClose() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => {
                if (this.modal) {
                    this.modal.classList.remove('is-open');
                }
            });
        }
    }

    initModalPosition() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const isOpen = this.modal.classList.contains('is-open');
                    if (isOpen) {
                        if (this.header) {
                            this.header.classList.remove('header--scrolling');
                            this.header.classList.add('header--edit-open');
                        }
                        document.body.style.overflow = 'hidden';
                        this.updateModalPosition();
                    } else {
                        document.body.style.overflow = '';
                        if (this.header) {
                            this.header.classList.remove('header--edit-open');
                        }
                    }
                }
            });
        });

        if (this.modal) {
            observer.observe(this.modal, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    updateModalPosition() {
        if (!this.modalContent || !this.header) return;

        const headerHeight = this.header.offsetHeight;

        if (this.modalContentWrap) {
            const windowHeight = window.innerHeight;
            const maxHeight = windowHeight - headerHeight;
            this.modalContentWrap.style.maxHeight = `${maxHeight}px`;
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    new EditModal();
});
